import moment from 'moment';
import React, { useCallback } from 'react';
import { useParams } from 'react-router';
import { useCommunitySubEvent } from '../../../data/hooks/communityHooks';
import { useEvent } from '../../../data/hooks/eventHooks';
import { useI18n } from '../../../data/hooks/i18nHooks';
import { eventMomentFactory } from '../../../data/misc/eventMomentFactory';
import SandboxedContent from '../../SandboxedContent/SandboxedContent';
import Scrollable from '../../elements/Scrollable';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import LoadEvent from '../../loaders/LoadEvent';
import HasData from '../../validate/HasData';
import EventDateAndTime from '../EventHomeScreen/common/EventDateAndTime/EventDateAndTime';
import EventHeaderImage from '../EventHomeScreen/common/EventHeaderImage/EventHeaderImage';
import EventLocation from '../EventHomeScreen/common/EventLocation/EventLocation';
import JoinEvent from '../EventHomeScreen/common/JoinEvent/JoinEvent';
import Screen from '../Screen';
import JoinMeetingButton from './innerComponents/JoinMeetingButton/JoinMeetingButton';

const CommunityItemEventScreen = props => {
    const {communityId, eventId} = props,
        community = useEvent(communityId),
        event = useCommunitySubEvent(communityId, eventId),
        i18n = useI18n(),
        start = eventMomentFactory(community, event.start_utc).subtract('10', 'minutes'),
        end = eventMomentFactory(community, event.end_utc);

    const header = (
            <div>
                <TopBarEvent event={community}>{event.name}</TopBarEvent>
            </div>
        ),
        footer = moment().isBefore(end) ? <JoinEvent eventId={eventId} i18n={i18n} /> : null;

    return (
        <Screen header={header} footer={footer}>
            <Scrollable className="graybg">
                <EventHeaderImage event={event} />
                <br />
                <div className="whitebg">
                    <EventDateAndTime event={community} start={event.start_utc} end={event.end_utc} />
                    <EventLocation event={event} />
                </div>
                <hr />
                <br />
                <div className="content">
                    {event.joined ? (
                        <>
                            <JoinMeetingButton eventId={eventId} type={event.agenda_type} url={event.meeting_link} start={start} end={end}>
                                {i18n['button.enter_room']}
                            </JoinMeetingButton>
                            <br />
                            <br />
                        </>
                    ) : null}
                    <SandboxedContent content={event.signup_html} fitHeightToContents noInnerPadding />
                </div>
            </Scrollable>
        </Screen>
    );
};

export default props => {
    const {communityId, eventId} = useParams(),
        check = useCallback(state => state.events[communityId].event.subevents.find(se => se.id == eventId), [communityId, eventId]);

    return (
        <LoadEvent eventId={communityId}>
            <HasData check={check}>
                <CommunityItemEventScreen communityId={communityId} eventId={eventId} />
            </HasData>
        </LoadEvent>
    );
};
